module.exports = __webpack_public_path__ + "img/emoney.b408c1e4.png";